import Vue from 'vue'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { EntityIdentifiersRequest, EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'
import {
    ShipmentRuleCreateRequest, ShipmentRulePatchInBatchRequest,
    ShipmentRuleResponse
} from '@/modules/configurationModule/detail/shipments/shipment-rules/services/shipment-rule/shipment-rule.dto'

export default class ShipmentRuleService extends Vue {
    async paginator(filterModel: any, params: any): Promise<IResponseAgGrid<ShipmentRuleResponse>> {
        const response = await this.axios.put<IResponseAgGrid<ShipmentRuleResponse>>(`/configuration/shipmentRules/`, filterModel, { params })
        return response.data
    }
    async getShipmentRuleById(shipmentRuleId : number): Promise<ShipmentRuleResponse> {
        const response = await this.axios.get<ShipmentRuleResponse>(`/configuration/shipmentRules/${shipmentRuleId}`)
        return response.data
    }
    async patchShipmentRulesBatch(request: ShipmentRulePatchInBatchRequest[]): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await this.axios.patch<EntityIdentifierWithErrorResponse[]>(`/configuration/shipmentRules/batch`, request)
        return response.data
    }
    async createShipmentRule(request: ShipmentRuleCreateRequest): Promise<ShipmentRuleResponse> {
        const response = await this.axios.post<ShipmentRuleResponse>(`/configuration/shipmentRules/`, request)
        return response.data
    }
    async deleteShipmentRulesBatch(request: EntityIdentifiersRequest): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await this.axios.delete<EntityIdentifierWithErrorResponse[]>(`/configuration/shipmentRules/batch`, { data: request })
        return response.data
    }
}

export const shipmentRuleService = new ShipmentRuleService()
